/**
 * Off until launch. When true + PUBLIC false → admin/testers only.
 * Set PUBLIC true when ready for everyone.
 */
export const ANNOUNCEMENT_BANNER_ENABLED = true;

/** When true (and ENABLED), every visitor sees the banner (still respects dismiss). */
export const ANNOUNCEMENT_BANNER_PUBLIC = false;

/** Bump this key when launching a new announcement so prior dismissals do not hide it. */
export const ANNOUNCEMENT_BANNER_STORAGE_KEY = 'prairi_announcement_v3_1_dismissed';

export const ANNOUNCEMENT_BANNER_LEAD = 'PRAIRI v3.1 is here:';
export const ANNOUNCEMENT_BANNER_BODY = 'Smarter matching. Faster discovery. Direct messaging.';
